import apiClient from "./apiClient";
import { ApiError } from "./smartColumnApiService";


export interface PivotTableGenerateRequest {
    table: any[][];
    user_intent: string;
}

export interface ValueObj {
    field: string;
    aggregation: string;
}

export interface PivotTableGenerateResponse {
    rows: string[];
    columns: string[];
    values: ValueObj[];
}

class PivotTableApiService {

    async generatePivotTable(request: PivotTableGenerateRequest): Promise<PivotTableGenerateResponse> {
        try {
            const response = await apiClient.post<PivotTableGenerateResponse>(
                '/pivot_table/generate',
                request
            );
            return response.data;
        } catch (error: any) {
            console.error('❌ Error generating pivot table:', error);
            const apiError: ApiError = {
                detail: error.message || "Failed to generate pivot table",
                status: error.status || 0,
            };
            throw apiError;
        }
    }

}

const pivotTableApiService = new PivotTableApiService();
export default pivotTableApiService;
